import { elementScrollIntoView } from "seamless-scroll-polyfill";

const labelsWraps = document.querySelectorAll(".js-card-info-labels-width-controller-init");

if (!window.mobileMedia && labelsWraps) {
    window.addEventListener("load", () => {
        labelsWraps.forEach((labelsWrap) => cardInfoLabelsWidthController(labelsWrap));
    });
}

function cardInfoLabelsWidthController(labelsWrap) {
    const labels = labelsWrap.querySelectorAll("[data-width-controller-target]");

    if (labels) {
        if (labels.length > 3) {
            labelsWrap.style.removeProperty("gap");
            labelsWrap.style.gap = "unset";
            labelsWrap.style.justifyContent = "space-between";
        } else {
            labelsWrap.style.removeProperty("justifyContent");
            labelsWrap.style.gap = "36px";
        }
    }
}

const kitProfitLink = document.querySelector(".card-info__kit-profit");
if (kitProfitLink) initScrollingElements(kitProfitLink);

const readMoreLink = document.querySelector(".read-more__link");
if (readMoreLink) initScrollingElements(readMoreLink);

function initScrollingElements(element) {
    const hash = element.getAttribute("href")?.replace("#", "");
    const block = hash ? document.getElementById(hash) : null;

    element.addEventListener("click", (e) => {
        e.preventDefault();

        if (block) {
            elementScrollIntoView(block, { behavior: "smooth", block: "center" });
        }
    });
}
